const url = new URL(window.location.href);

let HTTP_ENDPOINT = window['_localApi'] ?? url.origin;
let ENDPOINT = HTTP_ENDPOINT.replace("https://", "").replace("http://", "");

let HTTP_API_ENDPOINT = window['_localApi'] ? window['_localApi'] + "/api": `${url.origin}/api`;

let GALLERY_ENDPOINT = `https://desirehub.com/galleries`;

export {ENDPOINT, HTTP_ENDPOINT, HTTP_API_ENDPOINT, GALLERY_ENDPOINT};